/**
 * ``distribution.*`` event schemas — placeholder for Phase 2+ module.
 *
 * The Distribution module does not exist yet (no ``ModuleType``
 * value, no routes, no UI). This file is a stub so the registry's
 * ``...distributionEvents`` spread doesn't have to wait on a new
 * file when the module ships — see the module-extension pattern in
 * ``plans/PLAN_POSTHOG_02_EVENT_CATALOG.md`` § "Module-extension
 * pattern".
 */

export const distributionEvents = [] as const;
